<ion-content>
  <div class="app-store">
    <ion-header class="ion-no-border">
      <ion-toolbar mode="ios">
          <ion-buttons slot="start">
              <ion-back-button class="ion-hide-md-up"></ion-back-button>
              <ion-menu-button class="ion-hide-md-up" menu="left-menu"></ion-menu-button>
          </ion-buttons>
          <ion-img slot="start"
                  class="header__logo ion-hide-md-down"
                  [routerLink]="['/']"
                  src="{{ settings.logo }}"
                  alt="Organization Logo"></ion-img>

          <ion-title slot="end" class="ion-hide-md-down">
              <nav class="header__nav">
                  <!-- Login -->
                  <div class="header__nav-item" (click)="openLoginModal()">Login</div>
              </nav>
          </ion-title>
          <ion-title class="ion-hide-md-up">
              <ion-img class="header__logo"
                      [routerLink]="['/']"
                      src="{{ settings.logo }}"
                      alt="Organization Logo"></ion-img>
          </ion-title>

    <!--        <ion-buttons slot="end"></ion-buttons>-->
      </ion-toolbar>
    </ion-header>
    <div class="app-store__hero hero-section d-flex align-items-center justify-content-center text-center text-white">
      <div class="overlay"></div>
      <div class="app-store__container container content">
        <p class="app-store__hero-title">Find your new investment opportunities</p>
        <p class="app-store__hero-description">Discover exclusive investment opportunities, explore detailed property insights, and make offers directly through our streamlined platform. Find your next profitable venture with ease.</p>
        <div class="app-store__download-buttons">
          <div *ngIf="isApple">
            <a href="https://apps.apple.com/us/app/vesta-realty/id6737479817" target="_blank">
              <img src="../../../assets/img/apple-app-download.png"/>
            </a>
          </div>
          <div *ngIf="isAndroid">
            <a href="https://play.google.com/store/apps/details?id=com.vesta.v2.app" target="_blank">
              <img src="../../../assets/img/google-app-download.png"/>
            </a>
          </div>
          <div *ngIf="!isApple && !isAndroid">
            <div class="app-store__download-button">
              <a href="https://apps.apple.com/us/app/vesta-realty/id6737479817" target="_blank">
                <img src="../../../assets/img/apple-app-download.png"/>
              </a>
            </div>
            <div class="app-store__download-button">
              <a href="https://play.google.com/store/apps/details?id=com.vesta.v2.app" target="_blank">
                <img src="../../../assets/img/google-app-download.png"/>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="app-store__contact">
      <p class="app-store__contact-title">Contact & support</p>
        <form [formGroup]="contactForm" (ngSubmit)="submitForm()">
          <ion-grid>
            <ion-row>
              <ion-col size="12">
                <ion-item>
                  <ion-label position="floating">Name</ion-label>
                  <ion-input formControlName="name" type="text"></ion-input>
                </ion-item>
              </ion-col>

              <ion-col size="12">
                <ion-item>
                  <ion-label position="floating">Email</ion-label>
                  <ion-input formControlName="email" type="email"></ion-input>
                </ion-item>
              </ion-col>
              <ion-col size="12">
                <ion-item>
                  <ion-label position="floating">Message</ion-label>
                  <ion-textarea formControlName="message"></ion-textarea>
                </ion-item>
              </ion-col>
              <ion-col size="12">
                <ion-button expand="full" type="submit" [disabled]="contactForm.invalid">Submit</ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </form>
    </div>
  </div>
  <div class="app-store__footer">
    <em>Powered by
        <a class="app-store__footer-link" href="https://vesta.app" target="_blank">
            Vesta
        </a>
    </em>
    <br>
    <em>Copyright &copy; {{copyrightYear}}, All rights reserved.
        <a class="app-store__footer-link" href="https://vesta.app/privacy" target="_blank">
            Privacy Policy
        </a>.
    </em>
</div>
</ion-content>
